import React from "react"
import {FieldGlistEditableProps} from "../../../../render/glist/glist-editable"
import {FieldViewSize} from "../../../../const"

export default function FieldNavigationDisplayIn_GListEditable(props:FieldGlistEditableProps) {

    if (props.model.type === 'separator') return null

    // const options = props.field.getOptionsForEdit(props.model)
    // if (options.length < 2) {
    //     return <props.field.renderComponents.glistView className="p-l-10" {...props}/>
    // } else {
        return <props.field.renderComponents.editable size      = {FieldViewSize.SMALL}
                                                      field     = {props.field}
                                                      model     = {props.model}
                                                      onChange  = {props.onChange}/>
    // }
}
